export default __webpack_public_path__ + "photo-icon.fd395b9ef82e06e34d9ee5fc6e6cabca.svg";